document.addEventListener('DOMContentLoaded', function() {
	 getHeaderFooter();
});

// style - toto.css
// js - toto.js

  async function getHeaderFooter() {
    try {
      const response = await fetch('/toto_header_footer'); 
   
      if (!response.ok) {
        throw new Error('Unable to fetch header')
      };

      const json = await response.json();
      $('#toto-header').html(json.data.header);
      $('#toto-footer').html(json.data.footer);

     } catch (error) {
       console.error('Fetch error:', error)
     }
  }


